import React from 'react';
import styles from './style/deposit_message_style.module.scss'
import { connect } from 'react-redux';
import { getAdvancePercent } from '../../../store/login/reducers';
import Translation from '../../global/Translation';

const mapStateToProps = (state) => ({
    advancePercent: getAdvancePercent(state),
});

const DepositMessage = ({ messageType, advancePercent }) => {
    if (!messageType) {
        return null;
    }

    let translation = null;
    switch (messageType) {
        case 'INITIAL':
            translation = (
                <Translation
                    id={'CTS_50_PERCENT_DEPOSIT_INITIAL_MSG'}
                    defaultMessage={'For custom-made products, a {advancePercent}% deposit (including taxes) is required to confirm the order. The estimated delivery date depends on the {advancePercent}% payment. Production will begin once payment has been received.'}
                    values={{ advancePercent }}
                />
            );
            break;
        case 'FINAL':
            translation = (
                <Translation
                    id={'CTS_50_PERCENT_DEPOSIT_FINAL_MSG'}
                    defaultMessage={'To begin manufacturing your custom product, you must make a {advancePercent}% payment (taxes included). You will receive an email with instructions on how to complete this payment.'}
                    values={{ advancePercent }}
                />
            );
            break;
        case 'CUSTOM_MADE':
            translation = (
                <Translation
                    id={'deposit_message_custom_made_products'}
                    defaultMessage={'Important: To begin production of your order, as this is a custom-made product, a {advancePercent}% deposit (including taxes) is required. The estimated delivery date depends on payment of the {advancePercent}%. You will receive an email with instructions on how to complete this payment.'}
                    values={{ advancePercent }}
                />
            );
            break;
        default:
            return null;
    }

    return (
        <div className="alert-box-desktop">
            <div>
                <div
                    className={`alert mb-1 mt-1 alert-warning ${styles['cts-deposit-message']}`}
                    role="alert"
                >
                    <div className="d-flex align-items-baseline">
                        <div className="mr-2">
                            <i className="fas fa-exclamation-triangle" style={{ fontSize: '16px' }} />
                        </div>
                        <div>{translation}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default connect(mapStateToProps, null)(DepositMessage);